<template>
  <div class="content">
    <v-stepper v-model="el">
      <v-stepper-header>
        <v-stepper-step
          :complete="el > 1"
          :editable="el > 1"
          step="1"
          color="#0c88c2"
        >
          Fill the new client form
        </v-stepper-step>
        <v-divider></v-divider>

        <v-divider></v-divider>
        <v-stepper-step
          :complete="el > 2"
          :editable="el > 2"
          step="2"
          color="#0c88c2"
        >
          Select your delivery dates and time slots
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          :complete="el === 4"
          step="3"
          color="#0c88c2"
        >
          Wait for our team's confirmation
        </v-stepper-step>
      </v-stepper-header>
      <v-divider></v-divider>
      <v-stepper-items>
        <v-stepper-content step="1" class="pt-0" :class="{'px-0': $vuetify.breakpoint.smAndDown}">
          <ClientForm :client-files="clientFiles"
                      :applicationKey="applicationKey"
                      :client="client"
                      :edit="false"
          ></ClientForm>
        </v-stepper-content>

        <v-stepper-content step="2">
        </v-stepper-content>

        <v-stepper-content step="3">
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

  </div>
</template>

<script>
  import router from '../modules/router/index'
  import ClientForm from "./util/CreateClient/ClientForm";
  import axios from 'axios'

  export default {
    name: "CreateClient",
    components: {ClientForm},
    data() {
      return {
        el: 1,
        applicationName: null,
        applicationKey: null,
        clientFiles: [],
        client: {
          client_name: null,
          company_background: null,
          client_logo: '',
          delivery_frequency: null,
          anticipated_volume: null,
          type_of_food: null,
          production_address: null,
          production_details: null,
          packaging_type: null,
          multiple_sizes: null,
          size_dimensions: null,
          heavy_box: null,
          fit_by_pallet: null,
          sorting_warehouse: null,
          list_of_products: null,
          barcode_column: null,
          label_information: null,
          client_label: null,
          portal_access: null,
          google_email: null,
          ops_contact: [],
          cc_contact: [],
          other_contacts: [],
          ops_email: null,
          legal_name: null,
          abn: null,
          accounting_address: null,
          acc_details: null,
          payment_terms: null,
          copy_of_response: null,
          manifestSample: '',
          delivery_dates: null,
          delivery_timewindows: null,
        },
      }
    },

    beforeMount() {
      if (this.$route.query.application_key !== null && this.$route.query.application_key !== undefined) {
        this.applicationKey = this.$route.query.application_key;
        axios.get(process.env.API_URL + '/clientapplications/' + this.applicationKey + '/clientcontent')
          .then((response) => {
            if (response.data !== null) {
              if (Object.keys(response.data).includes('approved')) {
                // Some fields have already been approved by internal user
                this.client = response.data.client;
              } else {
                this.client = response.data
              }
            }
          })
          .catch((response) => {
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      } else if (!this.isInternalUser) {
        router.router.replace('/')
      }
    },
    computed: {
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      }
    }
  }
</script>

<style scoped>

  .content {
    margin-top: 0 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/CreateClient.vue